import { ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";
import { Card, CardContent } from "./ui/card";
import { formatPct } from "../lib/csv";
import Sparkline from "./Sparkline";

export default function KPICard({
  label,
  value,
  delta,
  inverse,
  icon: Icon,
  testId,
  hint,
  sparkline,
  sparklineColor = "#2563eb",
  accent = "blue",
}) {
  const numericDelta = typeof delta === "number" ? delta : 0;
  const positive = inverse ? numericDelta < 0 : numericDelta > 0;
  const neutral = numericDelta === 0;
  const TrendIcon = neutral
    ? Minus
    : positive
      ? ArrowUpRight
      : ArrowDownRight;
  const tone = neutral
    ? "text-slate-500 bg-slate-100"
    : positive
      ? "text-emerald-700 bg-emerald-50"
      : "text-rose-700 bg-rose-50";
  const accentMap = {
    blue: "bg-blue-50 text-blue-600",
    emerald: "bg-emerald-50 text-emerald-600",
    amber: "bg-amber-50 text-amber-600",
    rose: "bg-rose-50 text-rose-600",
    violet: "bg-violet-50 text-violet-600",
  };
  const iconClass = accentMap[accent] || accentMap.blue;

  return (
    <Card
      className="group relative overflow-hidden border-slate-200 shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md"
      data-testid={testId}
    >
      <span className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-blue-200 to-transparent opacity-0 transition-opacity group-hover:opacity-100" />
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <span className="text-xs font-medium uppercase tracking-wide text-slate-500">
            {label}
          </span>
          {Icon && (
            <div className={`flex h-8 w-8 items-center justify-center rounded-md ${iconClass}`}>
              <Icon className="h-4 w-4" />
            </div>
          )}
        </div>
        <div
          className="mt-3 font-heading text-4xl font-semibold tracking-tight text-slate-900"
          data-testid={`${testId}-value`}
        >
          {value}
        </div>
        {sparkline && sparkline.length > 1 && (
          <div className="mt-2" data-testid={`${testId}-sparkline`}>
            <Sparkline data={sparkline} color={sparklineColor} height={32} />
          </div>
        )}
        <div className="mt-3 flex items-center gap-2">
          <span
            className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${tone}`}
            data-testid={`${testId}-delta`}
          >
            <TrendIcon className="h-3 w-3" />
            {numericDelta === 0 ? "0.0%" : formatPct(Math.abs(numericDelta))}
          </span>
          <span className="text-xs text-slate-500">{hint || "vs prior 30d"}</span>
        </div>
      </CardContent>
    </Card>
  );
}
